import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-view" }
const _hoisted_2 = { class: "menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, {
      title: _ctx.$route.name,
      iconType: "menu",
      onOnClickLeftIcon: _ctx.onClickLeftIcon
    }, null, 8, ["title", "onOnClickLeftIcon"]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuExpaned = false)),
              to: "/door-status-list"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("門鎖控制狀態")
              ])),
              _: 1,
              __: [4]
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMenuExpaned = false)),
              to: "/access-control-list"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("門禁系統管理")
              ])),
              _: 1,
              __: [5]
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMenuExpaned = false)),
              to: "/role-list"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("角色列表")
              ])),
              _: 1,
              __: [6]
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMenuExpaned = false)),
              to: "/user-list"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("人員列表")
              ])),
              _: 1,
              __: [7]
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              onClick: _ctx.logout,
              to: "/login"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("登出")
              ])),
              _: 1,
              __: [8]
            }, 8, ["onClick"])
          ])
        ], 512), [
          [_vShow, _ctx.isMenuExpaned]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_router_view)
  ]))
}